import React from 'react';

import { RovoReintroductionLauncher } from '@atlassian/rovo-reintroduction-modal/launcher';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { isStableUIEnabledForTests } from '@confluence/e2e-url-override/entry-points/isStableUIEnabledForTests.ts';
import { CrossJoinNudgesWithFlags } from '@confluence/cross-join-nudges';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const GrowthComponentsLoader = (): React.JSX.Element | null => {
	const { userId } = useSessionData();

	if (isStableUIEnabledForTests()) {
		return null;
	}

	return (
		<>
			<ErrorBoundary
				attribution={Attribution.GROWTH_PUMA}
				attributes={{
					errorBoundaryId: 'GlobalComponents-GrowthPuma',
				}}
			>
				<CrossJoinNudgesWithFlags />
			</ErrorBoundary>
			<ErrorBoundary
				attribution={Attribution.AI_MATE}
				attributes={{
					errorBoundaryId: 'GlobalComponents-RovoReintroduction',
				}}
			>
				<RovoReintroductionLauncher product="confluence" userId={userId ?? undefined} />
			</ErrorBoundary>
		</>
	);
};
